import Component from 'vue-class-component';
import { Inject, Vue } from 'vue-property-decorator';
import LoginService from '@/account/login.service';
import HomeMenu from '@/components/home-menu/home-menu.vue';
import BootstrapVue from 'bootstrap-vue';

Vue.use(BootstrapVue);
@Component({
  components: {
    'home-menu': HomeMenu,
  },
})
export default class Home extends Vue {
  @Inject('loginService')
  private loginService: () => LoginService;

  public manualesModalId = 'modal-manuales';

  mounted(): void {
    this.checkManuales();
  }

  public openLogin(): void {
    this.loginService().login();
  }

  public openManuales(): void {
    console.log('CLICK MANUALES');
    console.log('modal id:', this.manualesModalId);
    console.log('$bvModal:', this.$bvModal);
    this.$bvModal.show('modal-manuales');
  }

  // Manuales de usuario, se muestran una sola vez por sesión en la pantalla de login
  public checkManuales(): void {
    if (this.authenticated || sessionStorage.getItem('manualesLoginMostrados')) {
      return;
    }
    sessionStorage.setItem('manualesLoginMostrados', 'true');
    this.openManuales();
  }

  public get authenticated(): boolean {
    return this.$store.getters.authenticated;
  }

  public get username(): string {
    return this.$store.getters.account?.login ?? '';
  }
}
